import React from 'react';
import { Link, graphql } from 'gatsby';
import Img from 'gatsby-image';

import Layout from '@components/layout';
import LazyComponent from '@components/lazy-component';
import company from '@data/company.json';
import { cards } from '@data/home-cards.json';

import s from '@styles/pocetna.module.css';
import phoneIcon from '@images/phone-icon.svg';
import emailIcon from '@images/email-icon.svg';
import locationIcon from '@images/location-icon.svg';
import socialIcon from '@images/social-icon.svg';

const IndexPage = ({ data }) => {
  const imageMap = {};
  data.cardImages.edges.forEach(({ node }) => {
    imageMap[node.relativePath] = node.childImageSharp.fluid;
  });

  return (
    <Layout pagePath="/" pageDescription="Keso-Promet d.o.o. Zvornik — prodaja naftnih derivata, transport, proizvodnja brašna i betona, te gradnja stambeno-poslovnih prostora.">
      <section className={s.heroSection}>
        <span className={s.background}></span>
        <h1>Keso-Promet</h1>
        <div className="container">
          <div className="row justify-center">
            {cards.map(card => (
              <div className={`${s.card} col-md-6 col-lg-4`} key={card.to}>
                <Link to={card.to}>
                  {imageMap[card.image] ? (
                    <Img fluid={imageMap[card.image]} alt={card.alt} />
                  ) : (
                    <div style={{ height: 250, background: '#eee' }} />
                  )}
                  <div className={s.card__nameTile}>{card.label}</div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={s.aboutSection} id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <h2 className={s.aboutSection__title}>O nama</h2>
            </div>
            <div className="col-lg-9">
              <p>
                Keso-Promet d.o.o. je firma sa tradicijom dugom skoro 30 godina.
                Od prvog dana pa sve do danas nudimo kvalitet i pouzdanost našim
                klijentima što je garancija našeg uspjeha i velikog broja
                poslovnih partnera na području Bosne i Hercegovine i inostranog
                tržišta.
              </p>
              <p>
                Bavimo se trgovinom naftnih derivata, izvođenjem građevinskih
                radova, proizvodnjom betona, pružamo usluge transporta i
                proizvodnjom i prodajom mlinarskih proizvoda (Žitopromet d.o.o.).
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className={s.contactSection} id="contact">
        <hr />
        <div className="container-fluid">
          <h2>Kontakt</h2>
          <div className="row no-gutters">
            <div className={`col-sm-6 col-lg-3 ${s.contactSection__card}`}>
              <div className={s.card__icon}>
                <img src={phoneIcon} alt="Phone icon" />
              </div>
              <div className={s.card__data}>
                <div className={s.data__type}>Broj telefona</div>
                <div className={s.data__content}>
                  <a href={`tel:${company.contact.phone.replace(/[\s-]/g, '')}`}>{company.contact.phone}</a>
                </div>
              </div>
            </div>
            <div className={`col-sm-6 col-lg-3 ${s.contactSection__card}`}>
              <div className={s.card__icon}>
                <img src={emailIcon} alt="Email icon" />
              </div>
              <div className={s.card__data}>
                <div className={s.data__type}>Email</div>
                <div className={s.data__content}>
                  <a href={`mailto:${company.contact.email}`}>{company.contact.email}</a>
                </div>
              </div>
            </div>
            <div className={`col-sm-6 col-lg-3 ${s.contactSection__card}`}>
              <div className={s.card__icon}>
                <img src={locationIcon} alt="Location icon" />
              </div>
              <div className={s.card__data}>
                <div className={s.data__type}>Lokacija</div>
                <div className={s.data__content}>{company.contact.address}</div>
              </div>
            </div>
            <div className={`col-sm-6 col-lg-3 ${s.contactSection__card}`}>
              <div className={s.card__icon}>
                <img src={socialIcon} alt="Social icon" />
              </div>
              <div className={s.card__data}>
                <div className={s.data__type}>Društvene mreže</div>
                <div className={s.data__content}>
                  <p>
                    <span className="icon-facebook"></span>
                    <a
                      href={company.contact.social.facebook.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {company.contact.social.facebook.handle}
                    </a>
                  </p>
                  <p>
                    <span className="icon-instagram"></span>
                    <a
                      href={company.contact.social.instagram.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {company.contact.social.instagram.handle}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LazyComponent path="home-map" />
      </section>
    </Layout>
  );
};

export const query = graphql`
  query {
    cardImages: allFile(
      filter: {
        relativeDirectory: { in: ["hero", "cards"] }
      }
    ) {
      edges {
        node {
          relativePath
          childImageSharp {
            fluid(maxWidth: 600, quality: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;

export default IndexPage;
